import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { useSettings } from "@/lib/settings";
import { ImageUpload } from "@/components/ImageUpload";

const FIELDS = [
  ["site_title", "Site Başlığı"],
  ["tagline", "Slogan"],
  ["whatsapp_number", "WhatsApp Numarası (+90...)"],
  ["phone", "Telefon"],
  ["email", "E-posta"],
  ["address", "Adres"],
  ["working_hours", "Çalışma Saatleri"],
  ["map_embed_url", "Google Maps Embed URL"],
  ["instagram", "Instagram URL"],
  ["facebook", "Facebook URL"],
  ["twitter", "Twitter URL"],
  ["tiktok", "TikTok URL"],
];

const PDF_FIELDS = [
  ["pdf_title", "PDF Başlık", "TEKLİF"],
  ["pdf_product_section_title", "Ürün Detay Başlığı", "Ürün Detayları"],
  ["pdf_total_label", "Toplam Etiketi", "TOPLAM"],
  ["pdf_primary_color", "PDF Renk (#hex)", "#D97736"],
  ["pdf_validity_days", "Teklif Geçerlilik Süresi (gün)", "3"],
];

export default function AdminSettings() {
  const { refresh } = useSettings();
  const [form, setForm] = useState({});
  useEffect(() => {
    let cancelled = false;
    api.get("/settings")
      .then((r) => { if (!cancelled) setForm(r.data || {}); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const save = async () => {
    try {
      const payload = { ...form };
      if (payload.pdf_validity_days !== undefined && payload.pdf_validity_days !== "") {
        payload.pdf_validity_days = Number(payload.pdf_validity_days) || 3;
      }
      await api.put("/settings", payload);
      toast.success("Kaydedildi");
      refresh();
    } catch { toast.error("Hata"); }
  };

  return (
    <div data-testid="admin-settings">
      <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900 mb-8">Site Ayarları</h1>
      <div className="rounded-3xl bg-white border border-ink-100 p-8 max-w-3xl space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2 grid sm:grid-cols-2 gap-4">
            <ImageUpload value={form.logo_url || ""} onChange={(url) => setForm({ ...form, logo_url: url })} label="Logo" testId="settings-logo" />
            <ImageUpload value={form.favicon_url || ""} onChange={(url) => setForm({ ...form, favicon_url: url })} label="Favicon" testId="settings-favicon" />
          </div>
          {FIELDS.map(([k, l]) => (
            <div key={k} className={l.includes("Adres") ? "sm:col-span-2" : ""}>
              <Label className="text-xs uppercase tracking-widest font-bold">{l}</Label>
              <Input value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1.5" data-testid={`settings-${k}`} />
            </div>
          ))}
        </div>

        <div className="pt-4 mt-4 border-t border-ink-100">
          <h2 className="font-display font-bold text-lg text-ink-900">PDF Şablon Ayarları</h2>
          <p className="text-xs text-ink-500 mt-1">PDF teklifte görünen sabit metinler ve renk.</p>
          <div className="grid sm:grid-cols-2 gap-4 mt-3">
            {PDF_FIELDS.map(([k, l, ph]) => (
              <div key={k}>
                <Label className="text-xs uppercase tracking-widest font-bold">{l}</Label>
                <Input
                  value={form[k] ?? ""}
                  onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                  placeholder={ph}
                  type={k === "pdf_validity_days" ? "number" : "text"}
                  className="mt-1.5"
                  data-testid={`settings-${k}`}
                />
              </div>
            ))}
            <div className="sm:col-span-2">
              <Label className="text-xs uppercase tracking-widest font-bold">PDF Alt Bilgi Metni</Label>
              <Textarea rows={2} value={form.pdf_footer || ""} onChange={(e) => setForm({ ...form, pdf_footer: e.target.value })} className="mt-1.5" data-testid="settings-pdf_footer" />
              <p className="text-[11px] text-ink-500 mt-1">Boş bırakılırsa &quot;Bu teklif {form.pdf_validity_days || 3} gün süreyle geçerlidir.&quot; metni otomatik kullanılır.</p>
            </div>
          </div>
        </div>

        <Button onClick={save} className="gradient-primary text-white rounded-full"><Save className="h-4 w-4 mr-1.5" /> Kaydet</Button>
      </div>
    </div>
  );
}
